"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorybookProject = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _BrowserChrome = require("./BrowserChrome");

var _styles = require("./shared/styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ekyreqs2"
} : {
  target: "ekyreqs2",
  label: "Wrapper"
})();
var Attribution = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ekyreqs1"
} : {
  target: "ekyreqs1",
  label: "Attribution"
})(_styles.text.regularBold, ";display:flex;align-items:center;margin-top:12px;color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";");
var Logo = (0, _theming.styled)("img", process.env.NODE_ENV === "production" ? {
  target: "ekyreqs0"
} : {
  target: "ekyreqs0",
  label: "Logo"
})(process.env.NODE_ENV === "production" ? {
  name: "13ucq70",
  styles: "display:block;width:20px;height:20px;margin-right:6px"
} : {
  name: "13ucq70",
  styles: "display:block;width:20px;height:20px;margin-right:6px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var StorybookProject = function StorybookProject(_ref) {
  var logo = _ref.logo,
      name = _ref.name,
      inverse = _ref.inverse,
      address = _ref.address,
      showControls = _ref.showControls,
      image = _ref.image,
      https = _ref.https;
  var browserProps = {
    address: address,
    showControls: showControls,
    image: image,
    https: https
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_BrowserChrome.BrowserChrome, (0, _extends2["default"])({
    inverse: inverse
  }, browserProps)), /*#__PURE__*/_react["default"].createElement(Attribution, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(Logo, {
    src: logo,
    alt: "",
    loading: "lazy"
  }), name));
};

exports.StorybookProject = StorybookProject;